export default __webpack_public_path__ + "static/media/robot.eebb60c4.svg";